import { render } from "./BdmManager.vue?vue&type=template&id=1bd0443c&scoped=true"
import script from "./BdmManager.vue?vue&type=script&lang=js"
export * from "./BdmManager.vue?vue&type=script&lang=js"

import "./BdmManager.vue?vue&type=style&index=0&id=1bd0443c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd0443c"]])

export default __exports__